import history from "../history/history";

const goto = (path: string) => {
  return history.push(path);
};

export const historyService = {
  goto,
};
